import React, { useState } from "react";
import { FiMail, FiUsers } from "react-icons/fi";
import ForwardingAccounts from "./ForwardingAccounts";
import OrgForwardingAccounts from "./OrgForwardingAccounts";

const TABS = [
  {
    id: "allowed",
    label: "Allowed Forwarding Emails",
    icon: FiMail,
    description:
      "Allow users to receive email in their dashboard from any address they want. Mail sent to tech@muns.io from an address on a user's list shows up in that user's dashboard — add the list from here.",
  },
  {
    id: "org",
    label: "Share Org CEO Mailbox",
    icon: FiUsers,
    description:
      "Set the CEO of the company and a list of user emails. Emails received by the CEO will also be reflected in those users' accounts.",
  },
];

const BrokerDashOperations = ({ onClose }) => {
  const [activeTab, setActiveTab] = useState(TABS[0].id);
  const tab = TABS.find((t) => t.id === activeTab) || TABS[0];
  const Icon = tab.icon;

  return (
    <div style={containerStyle}>
      <button type="button" onClick={onClose} style={closeButtonStyle}>
        Close
      </button>

      <h2 style={titleStyle}>Broker Dash Operations</h2>

      <div role="tablist" aria-label="Broker Dash Operations" style={tabListStyle}>
        {TABS.map((t) => {
          const selected = t.id === activeTab;
          return (
            <button
              key={t.id}
              type="button"
              role="tab"
              id={`bdo-tab-${t.id}`}
              aria-selected={selected}
              aria-controls={`bdo-panel-${t.id}`}
              onClick={() => setActiveTab(t.id)}
              style={{ ...tabStyle, ...(selected ? tabActiveStyle : null) }}
            >
              {t.label}
            </button>
          );
        })}
      </div>

      <div role="tabpanel" id={`bdo-panel-${tab.id}`} aria-labelledby={`bdo-tab-${tab.id}`}>
        <header style={headerStyle}>
          <span style={headerIconStyle}>
            <Icon aria-hidden="true" />
          </span>
          <div>
            <h3 style={panelTitleStyle}>{tab.label}</h3>
            <p style={descStyle}>{tab.description}</p>
          </div>
        </header>

        {tab.id === "allowed" ? (
          <ForwardingAccounts onClose={onClose} embedded />
        ) : (
          <OrgForwardingAccounts />
        )}
      </div>
    </div>
  );
};

const containerStyle = {
  width: "100%",
  maxWidth: "100%",
  // Fill the viewport below the breadcrumb so the dropdowns have room to open.
  minHeight: "calc(100vh - 140px)",
  boxSizing: "border-box",
};

const closeButtonStyle = {
  height: "40px",
  padding: "0 16px",
  boxSizing: "border-box",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#3730a3",
  color: "#ffffff",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
  fontWeight: "600",
  marginBottom: "20px",
};

const titleStyle = {
  color: "#3730a3",
  fontSize: "22px",
  fontWeight: "700",
  margin: "0 0 16px",
};

const tabListStyle = {
  display: "flex",
  flexWrap: "wrap",
  gap: "4px",
  borderBottom: "1px solid #c7d2fe",
  marginBottom: "20px",
};

const tabStyle = {
  padding: "10px 16px",
  fontSize: "14px",
  fontWeight: "600",
  color: "#6b7280",
  backgroundColor: "transparent",
  border: "none",
  borderBottom: "3px solid transparent",
  marginBottom: "-1px",
  cursor: "pointer",
};

const tabActiveStyle = {
  color: "#3730a3",
  borderBottomColor: "#3730a3",
};

const headerStyle = {
  display: "flex",
  alignItems: "flex-start",
  gap: "16px",
  marginBottom: "20px",
};

const headerIconStyle = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: "44px",
  height: "44px",
  flexShrink: 0,
  borderRadius: "10px",
  backgroundColor: "#e0e7ff",
  color: "#3730a3",
  fontSize: "20px",
};

const panelTitleStyle = {
  color: "#3730a3",
  fontSize: "18px",
  fontWeight: "700",
  margin: "0 0 6px",
};

const descStyle = {
  color: "#6b7280",
  fontSize: "14px",
  margin: 0,
};

export default BrokerDashOperations;
